import { Saturation } from 'react-color/lib/components/common';

/**
 * Override getContainerRenderWindow of Saturation class from react-colors
 * that caused a crash when trying to access parent's document
 */
export class CustomSaturation extends Saturation {
  getContainerRenderWindow() {
    return window;
  }
}
